import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await fetch('/api/auth/request', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await res.json();

      if (res.status === 403) {
        setError('Not Authorized');
        setLoading(false);
        return;
      }

      if (!res.ok) {
        setError(data.error || 'Something went wrong');
        setLoading(false);
        return;
      }

      navigate('/check-inbox');
    } catch (err) {
      setError('Connection error. Try again.');
      setLoading(false);
    }
  };

  return (
    <div className="container">
      <h1>Enhanced UIO</h1>
      <form onSubmit={handleSubmit}>
        <label htmlFor="email">Email Address</label>
        <input
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@tvi-mp3.com"
          required
          autoFocus
        />
        <div style={{ marginTop: 16 }}>
          <button type="submit" disabled={loading}>
            {loading ? 'Sending' : 'Submit'}
          </button>
        </div>
        {error && <div className="error">{error}</div>}
      </form>
      <div className="footer footer-row">
        <span>Internal Tool</span>
        <Link className="fallback-link" to="/fallback-login">Fallback Login</Link>
      </div>
    </div>
  );
}
